export const extractionFieldMappingOld = (
  t: (key: string) => string,
): Record<string, Record<string, string>> => ({
  postalCode: {
    label: t('conversationShowLeadQualifierDataPostalCode'),
    icon: '📍',
    category: 'location',
  },
  targetPrice: {
    label: t('conversationShowLeadQualifierDataTargetPrice'),
    icon: '💰',
    category: 'pricing',
  },
  productUsage: {
    label: t('conversationShowLeadQualifierDataProductUsage'),
    icon: '🏭',
    category: 'product',
  },
  monthlyVolume: {
    label: t('conversationShowLeadQualifierDataMonthlyVolume'),
    icon: '📦',
    category: 'volume',
  },
  preferredBrands: {
    label: t('conversationShowLeadQualifierDataPreferredBrands'),
    icon: '⭐',
    category: 'product',
  },
  purchaseFrequency: {
    label: t('conversationShowLeadQualifierDataPurchaseFrequency'),
    icon: '📅',
    category: 'frequency',
  },
  acceptsCounterTypes: {
    label: t('conversationShowLeadQualifierDataAcceptsCounterTypes'),
    icon: '🔄',
    category: 'flexibility',
  },
  productsUsuallyBought: {
    label: t('conversationShowLeadQualifierDataProductsUsuallyBought'),
    icon: '🛒',
    category: 'product',
  },
  additionalInformation: {
    label: t('conversationShowLeadQualifierDataAdditionalInformation'),
    icon: '📝',
    category: 'other',
  },
})

export const extractionFieldMappingNew = (
  t: (key: string) => string,
): Record<string, Record<string, string>> => ({
  postalCode: {
    label: t('conversationShowLeadQualifierDataPostalCode'),
    icon: '📍',
    category: 'location',
  },
  industry: {
    label: t('conversationShowLeadQualifierDataIndustry'),
    icon: '🏢',
    category: 'product',
  },
  isSample: {
    label: t('conversationShowLeadQualifierDataIsSample'),
    icon: '🧪',
    category: 'product',
  },
  quantity: {
    label: t('conversationShowLeadQualifierDataQuantity'),
    icon: '🔢',
    category: 'volume',
  },
  isBelowMOQ: {
    label: t('conversationShowLeadQualifierDataIsBelowMOQ'),
    icon: '⚠️',
    category: 'volume',
  },
  productType: {
    label: t('conversationShowLeadQualifierDataProductType'),
    icon: '📋',
    category: 'product',
  },
  productTitle: {
    label: t('conversationShowLeadQualifierDataProductTitle'),
    icon: '🏷️',
    category: 'product',
  },
  productUsage: {
    label: t('conversationShowLeadQualifierDataProductUsage'),
    icon: '🏭',
    category: 'product',
  },
  quantityUnit: {
    label: t('conversationShowLeadQualifierDataQuantityUnit'),
    icon: '📏',
    category: 'volume',
  },
  purchaseFrequency: {
    label: t('conversationShowLeadQualifierDataPurchaseFrequency'),
    icon: '📅',
    category: 'frequency',
  },
  acceptsCounterTypes: {
    label: t('conversationShowLeadQualifierDataAcceptsCounterTypes'),
    icon: '🔄',
    category: 'flexibility',
  },
  productAvailability: {
    label: t('conversationShowLeadQualifierDataProductAvailability'),
    icon: '📦',
    category: 'product',
  },
})

export const categoryColors = {
  location: 'var(--blue-600)',
  pricing: 'var(--green-600)',
  product: 'var(--purple-600)',
  volume: 'var(--orange-600)',
  frequency: 'var(--teal-600)',
  flexibility: 'var(--indigo-600)',
  other: 'var(--gray-600)',
} as const

export const formatExtractionValue = (key: string, value: unknown): string => {
  if (value === null || value === undefined) return 'N/A'

  if (Array.isArray(value)) {
    return value.length > 0 ? value.join(', ') : 'N/A'
  }

  if (typeof value === 'boolean') {
    return value ? 'Sim' : 'Não'
  }

  if (key === 'acceptsCounterTypes' && typeof value === 'string') {
    return value.toLowerCase() === 'sí' ||
      value.toLowerCase() === 'sim' ||
      value.toLowerCase() === 'yes'
      ? 'Sim'
      : 'Não'
  }

  if (typeof value === 'number') {
    return value.toString()
  }

  return String(value)
}
